import { create } from 'apisauce';
import { CancelToken } from 'axios';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import apiConfig from '../../config/apiConfig';
import responseStatus from '../../constants/requestStatus';

// set up cancel token from axios to be able to cancel network requests
const cancelSource = CancelToken.source();

const apiConfigWithCancelToken = {
  ...apiConfig,
  cancelToken: cancelSource.token,
};

const instance = create(apiConfigWithCancelToken);

instance.setAccessToken = (token) => {
  if (token) {
    instance.accessToken = token;
  }
};

instance.setCurrentOrganizationId = (organizationId) => {
  if (organizationId) {
    instance.currentOrganizationId = organizationId;
  }
};

instance.setAlertMessageCallback = (alertMessageFn) => {
  if (!instance.alertMessageFn && alertMessageFn) {
    instance.alertMessageFn = alertMessageFn;
  }
};

// Add a request interceptor
instance.addAsyncRequestTransform(
  (config) =>
    // Check and acquire a token before the request is sent
    new Promise((resolve, reject) => {
      if (instance.accessToken) {
        config.headers.Authorization = `Bearer ${instance.accessToken}`;
        resolve(config);
      } else if (config.url.includes('/application')) {
        // does not need to login to get the application version.
        resolve(config);
      } else {
        // Do something with error of acquiring the token
        reject(config);
      }
    }),
  (error) => {
    return Promise.reject(error);
  }
);

instance.addAsyncRequestTransform(
  (config) =>
    new Promise((resolve) => {
      config.headers.CurrentOrganizationId = instance.currentOrganizationId;
      resolve(config);
    }),
  (error) => {
    return Promise.reject(error);
  }
);

instance.addAsyncResponseTransform(async (response) => {
  // TODO: Improve responses handling

  if (response.status === responseStatus.BAD_REQUEST) {
    instance.alertMessageFn(
      'The operation failed. See error messages for more details.'
    );
    console.info('response.data', response.data);
    return;
  }
  if (response.status === responseStatus.UNPROCESSABLE_ENTITY) {
    instance.alertMessageFn(
      response.data,
      'Unprocessable Request',
      faExclamationTriangle,
      'color-text-warning'
    );
    console.info('response.data', response.data);
    return;
  }
  if (response.status === 401) {
    // window.location = '/unauthorized';
    return;
  }
  if (response.status === 403) {
    // window.location = '/forbidden';
    return;
  }
  if (response.status === 502) {
    instance.alertMessageFn(
      response.data.detail,
      response.data.title,
      faExclamationTriangle,
      'color-text-danger'
    );
    console.info('response.data', response.data);
    return;
  }
  if (response.config.headers.bubble_404) return;

  if (response.status === 404) {
    // window.location = '/pagenotfound';
    return;
  }

  if (response.status !== 200) {
    // window.location = `/problem/${response.status}/${response.problem}`;
    return;
  }
  return;
});

instance.logoutCallback = undefined;

export default instance;
